/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { ServerStatusDto } from '.././model';

import { apiInstance } from '../../whisApi.instance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const App_getServerStatus = (
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<ServerStatusDto>(
    { url: `/`, method: 'GET', signal },
    options,
  );
};

export const getAppGetServerStatusQueryKey = () => {
  return [] as const;
};

export const getAppGetServerStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof App_getServerStatus>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof App_getServerStatus>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof apiInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAppGetServerStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof App_getServerStatus>>
  > = ({ signal }) => App_getServerStatus(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof App_getServerStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AppGetServerStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof App_getServerStatus>>
>;
export type AppGetServerStatusQueryError = unknown;

export function useAppGetServerStatus<
  TData = Awaited<ReturnType<typeof App_getServerStatus>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof App_getServerStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof App_getServerStatus>>,
          TError,
          Awaited<ReturnType<typeof App_getServerStatus>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAppGetServerStatus<
  TData = Awaited<ReturnType<typeof App_getServerStatus>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof App_getServerStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof App_getServerStatus>>,
          TError,
          Awaited<ReturnType<typeof App_getServerStatus>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAppGetServerStatus<
  TData = Awaited<ReturnType<typeof App_getServerStatus>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof App_getServerStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useAppGetServerStatus<
  TData = Awaited<ReturnType<typeof App_getServerStatus>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof App_getServerStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAppGetServerStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
